<script setup>
import closeIcon from "@/assets/newPc/topup/close.png";
import {ref} from "vue";
const show = ref(false);

const open = () => {
  show.value = !show.value;
}

defineExpose({
  open
})
</script>

<template>
  <van-overlay class-name="custom_overlay" :lock-scroll="true" :show="show" @click="open">
    <div class="wrapper" @click.stop>
      <img class="close_icon" :src="closeIcon" @click="open" alt="">
      <div class="tips_title">宝石卡说明:</div>
      <div class="tips_content">
        <div>- 购买宝石卡后，将立即获得对应宝石（打开游戏后立即获得），每日还将免费获得额外宝石（游戏内邮件发放）；</div>
        <div>- 7天宝石卡：额外宝石权益持续7天，次日生效；</div>
        <div>- 30天宝石卡：额外宝石权益持续30天，次日生效；</div>
        <div>- 7天宝石卡和30天宝石卡购买后，可同时享受每日额外宝石权益；</div>
        <div>- 7天宝石卡和30天宝石卡生效期间，可再次购买宝石卡，再次购买后将立即获得对应宝石，并延长每日额外宝石权益的时间。</div>
      </div>
    </div>
  </van-overlay>
</template>

<style scoped lang="scss">
.custom_overlay {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}
.wrapper {
  width: 22.8515625vw;
  padding-bottom: 3.125vw;
  background: transparent url("@/assets/newPc/topup/tips_bg.png") no-repeat center center;
  background-size: cover;
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  box-sizing: border-box;
  font-family: "SHIYUAN";
  color: #A9AED0;

  .close_icon {
    position: absolute;
    top: 1.0546875vw;
    right: 1.3671875vw;
    width: 1.5625vw;
    height: 1.5625vw;
  }

  .tips_title {
    padding-top: 3.4765625vw;
    font-size: 1.015625vw;
    margin-bottom: 1.171875vw;
    padding-left: 1.7578125vw;
    width: 100%;
    box-sizing: border-box;
  }

  .tips_content {
    padding-left: 1.7578125vw;
    padding-right: 2.34375vw;
    width: 22.8515625vw;
    font-size: 0.859375vw;
    color: #A9AED0;
    overflow-y: auto;
    box-sizing: border-box;
    div {
      margin-bottom: 0.5859375vw;
      line-height: 1.5625vw;
    }
  }

}
</style>